import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    StyleSheet,
    TouchableOpacity,
    Platform
} from 'react-native';

import {
    JDText,
    JDImage,
    JDLogin,
    JDJumping
} from '@jdreact/jdreact-core-lib';

import { pt, mta, is_web, fetchLocal, getCookie } from '../../common/utils';

import img from '../../common/img';
const isWeb = Platform.OS === 'web';
class Nav extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            navList: [
                {
                    title: '电影',
                    img: img.movie,
                    curImg: img.movie_red
                },
                {
                    title: '演出',
                    img: img.piao,
                    curImg: img.piao_red
                },
                {
                    title: '礼遇',
                    img: img.gift,
                    curImg: img.gift_red
                },
                {
                    title: '我的',
                    img: img.my,
                    curImg: img.my_red
                }
            ],
            JRnavList: [
                {
                    title: '电影',
                    img: img.movie,
                    curImg: img.movie_red
                },
                {
                    title: '我的',
                    img: img.my,
                    curImg: img.my_red
                }

            ]
        };
    }

    render() {
        const { navList, JRnavList } = this.state;

        const { label, addZindex } = this.props;

        if (is_web && getCookie('movie_channel') == 4) {
            return (
                <View style={ [st.nav_wrap, is_web && { boxShadow: '0px 0px 8px -5px' }, is_web && addZindex && { zIndex: 7 }] }>
                    {JRnavList.map((item, index) => {
                        return (
                            <TouchableOpacity key={ index } style={ st.nav_item } onPress={ () => this.JRnavPress(index) }>
                                <View style={ st.nav_item_wrap }>
                                    <JDImage resizeMode='contain' style={ st.item_icon } source={ label == index ? item.curImg : item.img } />
                                    <JDText style={ [st.item_text, label == index && st.item_text_cur] }>{item.title}</JDText>
                                </View>
                            </TouchableOpacity>
                        );
                    })}
                </View>
            );
        } else {
            return (
                <View style={ [st.nav_wrap, is_web && { boxShadow: '0px 0px 8px -5px' }, is_web && addZindex && { zIndex: 7 }] }>
                    {navList.map((item, index) => {
                        return (
                            <TouchableOpacity key={ index } style={ st.nav_item } onPress={ () => this.navPress(index) }>
                                <View style={ st.nav_item_wrap }>
                                    <JDImage resizeMode='contain' style={ st.item_icon } source={ label == index ? item.curImg : item.img } />
                                    <JDText style={ [st.item_text, label == index && st.item_text_cur] }>{item.title}</JDText>
                                </View>
                            </TouchableOpacity>
                        );
                    })}
                </View>
            );
        }
    }

    navPress(index) {
        const { dispatch, label } = this.props;

        // this.context.router.toIndex();
        // return
        let url;

        switch (index) {
            case 0:
                if (label === index) { return; };
                dispatch({
                    type: 'change_label',
                    label: index
                });
                mta('MovieTab', 'Bottom');
                if (this.context.router.has('index')) {
                    this.context.router.goBack();
                } else {
                    // let hostUrl = location.origin
                    // window.location.replace(`${hostUrl}`);
                    // return
                    this.context.router.toIndex();
                }

                break;
            case 1:
                mta('ShowTab', 'Bottom');
                url = 'https://pro.m.jd.com/mall/active/3qMVzk9jNUJCAtf7CtVSYekyiVTn/index.html';
                JDJumping.jumpToWeb(url).catch(() => {});

                break;
            case 2:
                mta('NearByTab', 'Bottom');
                url = 'https://pro.m.jd.com/mall/active/3Y9H6rz1igtbdY9EvMGwgh8VUPMg/index.html'
                JDJumping.jumpToWeb(url).catch(err=>tip(err));
                break;
            case 3:
                if (label === index) { return; };
                mta('MyTab', 'Bottom');
                dispatch({
                    type: 'change_label',
                    label: index
                });
                this.context.router.jumpTo({ routeName: 'login' });
                break;

            default: break;
        }
    }

    JRnavPress(index) {
        const { dispatch, label } = this.props;

        switch (index) {
            case 0:
                if (label === index) { return; };
                dispatch({
                    type: 'change_label',
                    label: index
                });
                mta('MovieTab', 'Bottom');
                if (this.context.router.has('index')) {
                    this.context.router.goBack();
                } else {
                    this.context.router.toIndex();
                }

                return;
            case 1:
                if (label === index) { return; };
                mta('MyTab', 'Bottom');
                setTimeout(() => {
                    dispatch({
                        type: 'change_label',
                        label: index
                    });
                }, 0);
                this.context.router.jumpTo({ routeName: 'login' });

            default:
        }
    }
}

Nav.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    nav_wrap: {
        height: pt(50),
        flexDirection: 'row',
        backgroundColor: '#fff',
        shadowColor: 'green',
        shadowOffset: { width: 0, height: 10 },
        shadowRadius: 3,
        shadowOpacity: 0.8,
        elevation: 4
    },
    nav_item: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    nav_item_wrap: {
        alignItems: 'center'
    },
    item_icon: {
        width: pt(25),
        height: pt(24)
    },
    item_text: {
        color: '#898989',
        fontSize: pt(10),
        marginTop: pt(3)
    },
    item_text_cur: {
        color: '#E2231A'
    }
});

const select = (state) => {
    const { label } = state.index;

    return { label };
};

export default connect(select, null, null, { withRef: true })(Nav);
